<template>
  <div class="content-body">
    <div class="xinxi">
      <div class="title">
        查询条件
      </div>
      <el-select size="small" clearable v-model="plan_id" placeholder="计划" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" clearable v-model="group_id" placeholder="计划组" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" clearable v-model="adv_id" placeholder="创意" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.adv_title" :value="item.adv_id" v-for="(item, index) in advLists" :key="index"></el-option>
      </el-select>
      <el-button-group style="margin: 0 10px;">
        <el-button size="small" @click="dateType = 1" :type="dateType === 1 ? 'primary' : ''">今日</el-button>
        <el-button size="small" @click="dateType = 4" :type="dateType === 4 ? 'primary' : ''">昨日</el-button>
        <el-button size="small" @click="dateType = 2" :type="dateType === 2 ? 'primary' : ''">本周</el-button>
        <el-button size="small" @click="dateType = 3" :type="dateType === 3 ? 'primary' : ''">本月</el-button>
      </el-button-group>
      <el-button size="small" type="primary" icon="el-icon-search" @click="drawLine()">查询</el-button>
    </div>
    <div style="display: flex; background: #fff;">
      <div id="myChart" :style="{width: '1180px', height: '600px', marginLeft: '10px', marginTop: '10px'}"></div>
    </div>
    <div style="display: flex; padding-top: 60px; justify-content: center; background: #fff;">
      <div style="display: flex;">
        <div style="margin-right: 20px; font-weight: bold; color: 333;">网络环境分布</div>
        <div id="echarts-os" :style="{width: '460px', height: '300px', marginTop: '10px'}"></div>
      </div>
      <div style="display: flex; margin-left: 2%;">
        <div style="margin-right: 20px; font-weight: bold; color: 333;">操作系统分布</div>
        <div id="echarts-device_price" :style="{width: '460px', height: '300px', marginTop: '10px'}"></div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
import 'echarts/lib/chart/map';
import 'echarts/map/js/china.js';
export default {
  data() {
    return {
      value1: [],
      dateType: 3,
      plan_id: '',
      planLists: [],
      group_id: '',
      groupLists: [],
      adv_id: '',
      advLists: []
    };
  },
  mounted() {
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.drawLine();
      }
    });
    // this.drawLine();
    // setTimeout(() => {

    // }, 200);
  },
  methods: {
    drawLine() {
      this.$function.showLoading();
      let dateType = this.dateType;
      if (this.value1.length > 0) {
        dateType = this.value1.join(',');
      }
      this.$http.post('/trader/data/getAddressCount', {
        dateType,
        creativeId: this.adv_id,
        groupId: this.group_id,
        planId: this.plan_id
      }).then(result => {
        this.$function.hiddenLoading();
        if (result.code === 200) {
          const res = result.result;
          const area = res.areaJson;
          const areaName = [];
          for (let i = 0; i < area.length; i++) {
            areaName.push(area[i].name);
          }
          const areaValue = [];
          for (let i = 0; i < area.length; i++) {
            areaValue.push(area[i].value);
          }

          const option = {
            title: {
              text: '地域分布',
              subtext: '点击统计'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: areaName

            },
            series: [
              {
                name: '点击量',
                type: 'bar',
                data: areaValue,
                itemStyle: { // 上方显示数值
                  normal: {
                    label: {
                      show: true, // 开启显示
                      position: 'right', // 在上方显示
                      textStyle: { // 数值样式
                        color: 'black',
                        fontSize: 14
                      }
                    }
                  }
                }
              }
            ]
          };
          const echartsRecords = echarts.init(document.getElementById('myChart'), 'walden');
          echartsRecords.setOption(option);

          // 网络环境分布
          const options_demo5 = {
            legend: {},
            tooltip: {},
            dataset: {
              source: [
                ['product', 'Wifi', '4G', '其他'],
                ['数量', res['devicePriceJson'][0], res['devicePriceJson'][1], res['devicePriceJson'][2]]
              ]
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
              { type: 'bar', color: '#FFAF44', barWidth: 20, barGap: '300%' },
              { type: 'bar', color: '#15C1F7', barWidth: 20, barGap: '300%' },
              { type: 'bar', color: '#CE1EE0', barWidth: 20, barGap: '300%' }
            ]
          };

          const demo5 = echarts.init(document.getElementById('echarts-os'), 'walden');
          demo5.setOption(options_demo5);

          // 操作系统分析
          const options_demo6 = {
            legend: {},
            tooltip: {},
            dataset: {
              source: [
                ['product', 'Android', 'IOS', '网站'],
                ['数量', res['operateSystemJson'][0], res['operateSystemJson'][1], res['operateSystemJson'][2]]
              ]
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
              { type: 'bar', color: '#FFAF44', width: '20px', barWidth: 20, barGap: '300%' },
              { type: 'bar', color: '#15C1F7', barWidth: 20, barGap: '300%' },
              { type: 'bar', color: '#CE1EE0', barWidth: 20, barGap: '300%' }
            ]
          };

          const demo6 = echarts.init(document.getElementById('echarts-device_price'), 'walden');
          demo6.setOption(options_demo6);
        }
      });
    },
    selectDate(dateType) {
      this.value1 = [];
      this.dateType = dateType;
    }
  },
  watch: {
    plan_id(newVal, oldVal) {
      this.$http.post('/trader/index/getGroupForPlanId', {
        plan_id: newVal
      }).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          this.group_id = '';
          this.adv_id = '';
        }
      });
    },
    group_id(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/data/getAdvLists', {
          group_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.advLists = res.data;
            this.adv_id = '';
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped="">
  .xinxi {
    width: calc(100% - 50px);
    margin-top: 16px;
    padding: 25px;
    background: #fff;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      margin-bottom: 10px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
  .other-data {
    display: flex;
    padding: 10px;
    .ios, .andriod {
      width: 50%;
    }
  }
</style>
